const TiposPlanta = [
    { cod: "fixa", descricao: "Fixa"},
    { cod: "movel", descricao: "Movel"},
  ];

  export default TiposPlanta